import { render, staticRenderFns } from "./CategoryRow.vue?vue&type=template&id=2ec67dbf"
import script from "./CategoryRow.vue?vue&type=script&lang=js"
export * from "./CategoryRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports